import MyPayStubsPage from './MyPayStubsPage.vue'
import PayStubDetailsPage from './PayStubDetailsPage.vue'

export default [
    {
        path: '/my-paystubs',
        name: 'MyPayStubs',
        component: MyPayStubsPage,
        meta: { requiresAuth: true, roles: ['user', 'admin', 'superadmin'] }
    },
    {
        path: '/paystub/:id',
        name: 'MyPayStubDetails',
        component: PayStubDetailsPage,
        meta: { requiresAuth: true, roles: ['user', 'admin', 'superadmin'] }
    }
]
